/** File block helpers (spec §7.4.10, §8.14). Pure. */
export type Disposition = "inline" | "download";
export type OpenIn = "tab" | "window";

export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  const units = ["KB", "MB", "GB", "TB"];
  let v = n / 1024;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i++;
  }
  return `${v >= 10 ? Math.round(v) : v.toFixed(1)} ${units[i]}`;
}

/** Icon family from the declared media type (§8.14 point 2). */
export function fileIconKind(mime: string): IconKind {
  const [major = "", sub = ""] = mime.toLowerCase().split(";")[0]!.split("/");
  if (major === "image") return "image";
  if (major === "audio") return "audio";
  if (major === "video") return "video";
  if (sub === "pdf" || (major === "text" && sub === "plain")) return "text";
  if (/zip|tar|gzip|x-7z|rar|bzip|xz/.test(sub)) return "archive";
  if (/csv|spreadsheet|excel/.test(sub)) return "spreadsheet";
  if (major === "text" || /json|xml|yaml|javascript|x-sh|x-python|toml|sql/.test(sub)) return "code";
  return "file";
}

export type IconKind = "image" | "audio" | "video" | "text" | "archive" | "spreadsheet" | "code" | "file";

/** URL for opening a stored file; the block's disposition travels with the request (§10.4). */
export function assetOpenUrl(hash: string, disposition: Disposition): string {
  return disposition === "inline" ? `/api/assets/${hash}?disposition=inline` : `/api/assets/${hash}`;
}
